export function notifReducer(state = {
    message:"",
    type:"",
    show: false,
}, {
    type,
    payload
}){
    switch(type){
        case "SHOW_NOTIF":            
            return payload;

        case "CLEAN_NOTIF":
            let notif = {
                message:"",
                type:"",
                show: false,
            };
            return notif;

        default:
            return state;
    }
}